import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { useUiStore } from '@/store/ui';
import { IDtaUnidadTransporte, UnidadTransporte } from '@/shared/interfaces';

const { get, post, put } = erpApi();

///* tanSctack query
export const useFetchUnidadesTransporte = (params?: GetUnidadesTransporteParams) => {
  return useQuery({
    queryKey: ['adminUnidadesTransporte', ...Object.values(params || {})],
    queryFn: async () => {
      return getUnidadTransporte(params);
    },
  });
};

export const useGetUnidadesTransporte = (id: string) => {
  return useQuery({
    queryKey: ['adminUnidadesTransporte', id],
    queryFn: async () => {
      return getUnidadesTransporte(id);
    },
  });
};

export const useCreateUnidadesTransporte = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createUnidadesTransporte,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['adminUnidadesTransporte'] });

      navigate(returnUrl, { replace: true });
    },
  });
};

export const useUpdateUnidadesTransporte = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUnidadesTransporte,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['adminUnidadesTransporte'] });

      navigate(returnUrl);
    },
  });
};

///* axios
export type GetUnidadesTransporteParams = {
  page?: number;
  page_size?: number;
  nombre?: string;
  codigo?: string;
};
export type CreateUnidadesTransporteParams = Omit<
UnidadTransporte,
  'id_unidad_transporte'
>;
export type UpdateUnidadesTransporteParams = {
  id: string;
  data: CreateUnidadesTransporteParams;
};

export const getUnidadTransporte= async (params?: GetUnidadesTransporteParams) => {
  const { page = 1, page_size = 10, nombre = '' } = params || {};

  return get<UnidadTransporte>(
    `${urlBackend}api/v1/unidadtransporte/?page=${page}&page_size=${page_size}&nombre=${nombre}`,
    true
  );
};

export const getUnidadesTransporte = async (id: string) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await get<IDtaUnidadTransporte>(
    `${urlBackend}api/v1/unidadtransporte/${id}`,
    true
  );

  res.status === 'error' && setAlert(true, res.message, res.status);
  return res;
};

export const createUnidadesTransporte = async (data: CreateUnidadesTransporteParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await post<IDtaUnidadTransporte>(
    `${urlBackend}api/v1/unidadtransporte/`,
    data,
    true
  );

  setAlert(true, res.message, res.status);
  return res;
};

export const updateUnidadesTransporte = async ({
  id,
  data,
}: UpdateUnidadesTransporteParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<IDtaUnidadTransporte>(
    `${urlBackend}api/v1/unidadtransporte/${id}/`,
    data,
    true
  );

  setAlert(true, res.message, res.status);
  return res;
};
